/* eslint-disable no-console */
import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, useShowMessage } from '../../core-ui';

import { useFetchJson } from '../../support/useFetch';
import { safeInvokeAsync } from '../../core/support/safeInvokeAsync';

type Account = { id: string; name: string };

export function RemoveRecoveredPaymentsButton(props: {
  accounts: Array<Account>;
}) {
  const { accounts } = props;
  const fetchJson = useFetchJson();
  const showMessage = useShowMessage();
  const { mutate: doFix, isLoading } = useMutation(
    async () => {
      showMessage(
        'success',
        t('Fixing {count} accounts. Check console for details.', {
          count: accounts.length,
        }),
      );
      for (const [index, account] of accounts.entries()) {
        console.log(
          `Fixing "${account.name}" (${index + 1} of ${accounts.length})...`,
        );
        const [data, error] = await safeInvokeAsync(() =>
          fetchJson(
            `/api/manual-payments/${account.id}/remove-recovered-payments`,
          ),
        );
        if (error) {
          console.log('Error fixing account', account.id);
          console.error(error);
        } else {
          console.log(data);
        }
      }
    },
    {
      onSuccess: () => {
        showMessage('success', t('Fixed successfully'));
      },
      onError: (error) => {
        console.error(error);
        showMessage('error', t('Error fixing: {error}', { error }));
      },
    },
  );

  if (!accounts.length) {
    return null;
  }

  return (
    <Button isLoading={isLoading} onClick={() => doFix()}>
      {t('Remove recovered payments')}
    </Button>
  );
}
